import * as React from 'react'
import cc from 'classcat'
import Carousel from 'nuka-carousel'
import Testimonial from '../Testimonial'

import s from './styles.module.css'

export default class TestimonialsCarousel extends React.Component {
  carouselEl

  state = {
    selected: 1
  }

  onClick = selected => () => {
    this.setState({ selected }, () => {
      this.carouselEl.goToSlide(selected)
    })
  }

  render() {
    const { testimonials } = this.props

    return (
      <Carousel
        cellAlign="center"
        swiping
        slidesToShow={3}
        slidesToScroll={1}
        cellSpacing={25}
        className={s.carousel}
        slideIndex={1} // initial value
        renderBottomCenterControls={Function.prototype}
        ref={el => {
          this.carouselEl = el
        }}
      >
        {testimonials.map((testimonial, idx) => (
          <button
            key={`testimonial-${idx}`}
            className={s.clickable}
            onClick={this.onClick(idx)}
          >
            <Testimonial
              className={cc([s.testimonial, {
                [s.inactive]: idx !== this.state.selected
              }])}
              {...testimonial}
            />
          </button>
        ))}
        {/* Hidden items are hack for the carousel to think there are 2 more items displayed when we finally center last item, because it expects to show 3 slides at the time */}
        <Testimonial className={s.hiddenTestimonial} />
        <Testimonial className={s.hiddenTestimonial} />
      </Carousel>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/TestimonialsCarousel/index.js